import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 20px;
  margin-top: 40px;
`;

export const AnimalImage = styled.div`
  width: 110px;
  height: 110px;
  border-radius: 8px;
  background: var(--white-darker);
  position: relative;

  grid-row: 1 / 3;
  grid-column: 1 / 2;

  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  > span {
    position: absolute;
    top: 0;
    left: 0;
    background: var(--info);
    color: var(--white);
    border-radius: 8px;
    padding: 5px 14px;
    font-size: 14px;
    font-weight: bold;
    transform: translate(-8px, -8px);
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100px;

  > span {
    font-size: 14px;
    font-weight: 500;
    color: var(--gray-9);
  }

  > strong {
    font-size: 16px;
    color: var(--black-2);
  }
`;

export const IconContainer = styled.button`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  background: var(--black-transparent);
  cursor: pointer;
  outline: none;
  transition: box-shadow 0.2s ease-in-out;

  :focus {
    box-shadow: 0 0 0px 3px rgba(0, 0, 0, 0.2);
  }
`;

export const NavBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-x: hidden;
`;

interface ISmallButton {
  active: boolean;
}

export const SmallButton = styled.button<ISmallButton>`
  width: ${p => (p.active ? '160px' : 'auto')};
  height: 50px;
  border: 0;
  border-radius: 8px;
  padding: 0 20px;
  outline: none;
  color: var(--info);
  background: ${p => (p.active ? 'var(--info-transparent)' : 'none')};
  transition: all 0.4s;
  cursor: pointer;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  position: relative;

  > span {
    position: absolute;
    transform: ${p => (p.active ? 'translateX(40px)' : 'translateX(0)')};

    font-weight: 600;
    font-size: 16px;

    visibility: ${p => (p.active ? 'visible' : 'hidden')};
    opacity: ${p => (p.active ? 1 : 0)};
    transition: all 0.4s;
  }
`;

export const Section = styled.div`
  padding: 40px 0;
`;

export const SeeMoreButton = styled.button`
  width: 100%;
  height: 40px;
  color: var(--black-7);
  background: var(--white-darker);
  border: 0;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  padding: 0 25px;
  outline: none;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    margin-right: 10px;
  }
`;

export const SmallGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 20px;
  margin-bottom: 40px;

  > div {
    display: flex;
    align-items: center;
  }

  > div > div {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }

  > div > p {
    font-size: 12px;
    color: var(--gray-9);
  }

  > div > strong {
    font-size: 14px;
    color: var(--black-2);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > div > button {
    background: var(--white-darker);
    color: var(--info);
    font-weight: bold;
    border-radius: 8px;
    font-size: 14px;
    padding: 0 20px;
    height: 30px;
    width: 125px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
`;

export const Obs = styled.p`
  padding: 10px 20px 0 20px;
  color: var(--black-2);
`;

export const ParentsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin: 20px 0;

  > a {
    min-width: 0;
  }

  > a:hover {
    opacity: 1;
  }
`;

export const CustomGraphTooltip = styled.div`
  padding: 10px 20px;
  border-radius: 8px;
  background: var(--white);
  border: 1.5px solid var(--gray-e);

  > p {
    color: var(--info);
  }

  > p:first-child {
    color: var(--black-3);
  }
`;

export const Breadcumb = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  > svg {
    margin: 0 10px;
  }

  > span {
    color: var(--gray-9);
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }
`;
